import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import { BADGES, MARQUEE } from "@/data/content";
import { Reveal } from "@/components/motion";

const CountUp = ({ value, decimals, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.15 });
  const [v, setV] = useState(value);
  useEffect(() => {
    if (!inView) return undefined;
    const c = animate(0, value, { duration: 2, ease: [0.22, 1, 0.36, 1], onUpdate: setV });
    return () => c.stop();
  }, [inView, value]);
  return <span ref={ref}>{v.toFixed(decimals)}{suffix}</span>;
};

export const TrustStrip = () => (
  <section data-testid="trust-badges" className="bg-[#070A12] border-b border-[#C5A059]/15">
    <div className="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-12 grid sm:grid-cols-3 divide-y sm:divide-y-0 sm:divide-x divide-[#C5A059]/15">
      {BADGES.map((b, i) => (
        <Reveal key={b.label} delay={i * 0.1} className="py-10 sm:px-8 first:sm:pl-0 flex items-end gap-5" data-testid={`trust-badge-${i + 1}`}>
          <span className="font-display text-6xl lg:text-7xl text-bronze-grad leading-none">
            <CountUp value={b.value} decimals={b.decimals} suffix={b.suffix} />
          </span>
          <span className="pb-1">
            <span className="block text-slate-100 text-sm font-medium">{b.label}</span>
            <span className="block font-data text-[11px] tracking-widest uppercase text-slate-400 mt-1">{b.note}</span>
          </span>
        </Reveal>
      ))}
    </div>
  </section>
);

export const Marquee = () => {
  const items = [...MARQUEE, ...MARQUEE];
  return (
    <section data-testid="editorial-marquee" className="relative bg-[#0B1120] py-10 sm:py-14 overflow-hidden border-y border-[#C5A059]/10">
      <div className="marquee-track flex w-max whitespace-nowrap">
        {[0, 1].map((k) => (
          <div key={k} className="flex shrink-0" aria-hidden={k === 1}>
            {items.map((m, i) => (
              <span key={`${k}-${i}`} className="flex items-center font-display text-5xl sm:text-7xl lg:text-8xl px-6 sm:px-10">
                <span className={i % 2 ? "text-outline italic" : "text-slate-200"}>{m}</span>
                <span className="ml-12 sm:ml-20 w-3 h-3 rotate-45 border border-[#C5A059]/60" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};

export { CountUp };
